const DELIVERY_MODE_LABELS: Record<string, string> = {
  FULLY_AUTONOMOUS: 'Fully Autonomous',
  // Some endpoints (e.g. flight-summary / history) return the fully-autonomous mode as the
  // bare "AUTONOMOUS" token — treat it as Fully Autonomous so it never shows just "Autonomous".
  AUTONOMOUS: 'Fully Autonomous',
  SEMI_AUTONOMOUS: 'Semi Autonomous',
};

// Delivery mode is stored/sent as an upper-snake-case token (e.g. "SEMI_AUTONOMOUS").
// It must never be displayed raw — format known modes explicitly and fall back to a
// title-cased version of the token for any unknown values.
export const formatDeliveryMode = (mode?: string | null): string => {
  if (!mode) return '';

  const known = DELIVERY_MODE_LABELS[mode.toUpperCase()];
  if (known) return known;

  return mode
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
